import type { NavCategory, NavCategoryWithParent } from "../types";

export function getCategoriesMap(categories: NavCategory[]) {
  const map = new Map<string, NavCategoryWithParent>();

  function traverseCategory(category: NavCategory, parent?: NavCategory) {
    Object.assign(category, { parentHref: parent?.href });
    map.set(category.href, category);
    category.children?.forEach((child) => traverseCategory(child, category));
  }

  categories.forEach((category) => traverseCategory(category, undefined));

  return map;
}
